<csd-snackbar-item
  *ngFor="let item of items$ | async; trackBy: trackById"
  [text]="item.text"
  [level]="item.level"
  (close)="item.closeFn()"
/>
